// extracted by mini-css-extract-plugin
export var cardHeader = "_fb-0";
export var reorderHandle = "_fb-3";
export var titleArea = "_fb-1";
export var titleAreaWithHandle = "_fb-2";